module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "asset_envelope.8b888314.svg";